import {match} from 'ts-pattern';

import {CustomSectionId} from '../consts/customSectionsId';
import {isB2cCarAuditWorkspace} from './isB2cCarAuditWorkspace';
import {isCarvagoWorkspace} from './isCarvagoWorkspace';

export function isCustomSectionVisible(sectionId: CustomSectionId) {
  return match<CustomSectionId>(sectionId)
    .with('HISTORY_CHECK', isCarvagoWorkspace)
    .with('SIMILAR_CARS', isB2cCarAuditWorkspace)
    .exhaustive();
}
